import { Component } from '@angular/core';

import {
  Router,
  // import as RouterEvent to avoid confusion with the DOM Event
  Event as RouterEvent,
  NavigationStart,
  NavigationEnd,
  NavigationCancel,
  NavigationError
} from '@angular/router';
import {Subject} from 'rxjs';
import {debounceTime} from 'rxjs/operators';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TermsAndConditionDialog } from './Core/TermsAndConditionDialog/TermsAndConditionDialog';
import { PrivacyPolicyDialog } from './Core/PrivacyPolicyDialog/PrivacyPolicyDialog';
import { Globals } from './globals';
import { VersionCheckService } from './API/version-check.service';
import { environment } from '../environments/environment';
import { MessageService } from 'primeng/api';
import domtoimage from 'dom-to-image';
import html2canvas from 'html2canvas';
import { ErrorDialog } from './Core/Shared/ErrorDialog/ErrorDialog';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  // Sets initial value to true to show loading spinner on first load
 public static loading = false;
 public static alerts = [];
 static UpdateNotification: any;
public static MenuWidth = 0;
public dialogRef: MatDialogRef<TermsAndConditionDialog>;
  public static messageService: MessageService; // <-- static reference

constructor(
  public dialog: MatDialog,
  private router: Router,
  private versionCheck: VersionCheckService,
  private messageService: MessageService
) {
      AppComponent.messageService = this.messageService; // assign it during construction
  }

// public static addAlert(message, typeP) {
//  //   console.log("Inside Add Alers"+message);
//     AppComponent.alerts.filter(x=>x.successMessage==true).map(x=>x.successMessage=null);

//     let timeoutSeconds = parseInt(Globals.defaultTimeForAlert);

//     if(typeP == "error" && message != Globals.FormErrorMessage)
//       timeoutSeconds = parseInt(Globals.defaultTimeForErrorAlert);

//     const _success = {msg: message, type: typeP, successMessage: true};
//     setTimeout(() => _success.successMessage = null, timeoutSeconds);
//     AppComponent.alerts.push(_success);

//     setTimeout(() =>{
//       // let errorText = document.querySelectorAll('ngb-alert div span')
//       // try {
//       //   errorText[errorText.length - 1].innerHTML ='OK';
//       // } catch (error) {

//       // }
//        this.messageService.add({
//           severity: _success.type,
//           detail: _success.msg,
//           life: 2000,  
//           key: 'bottomToast',
//          });

//     },50);
//   }

public static addAlert(message: string, typeP: 'success' | 'error' | string): void {
    // Clear previous success messages
    AppComponent.alerts.forEach(alert => {
      if (alert.successMessage) {
        alert.successMessage = null;
      }
    });

    // Determine timeout duration
    const isFormError = message === Globals.FormErrorMessage;
    const timeoutSeconds = typeP === 'error' && !isFormError
      ? parseInt(Globals.defaultTimeForErrorAlert)
      : parseInt(Globals.defaultTimeForAlert);

    // Create alert object
    const alertObj = {
      msg: message,
      type: typeP,
      successMessage: true
    };

    // Add alert to the list
    AppComponent.alerts.push(alertObj);

    // Remove alert success flag after timeout
    setTimeout(() => {
      alertObj.successMessage = null;}, timeoutSeconds);

    // Show toast message
    setTimeout(() => {
      this.messageService.add({
        severity: alertObj.type,
        detail: alertObj.msg,
        life: 2000,
        key: 'bottomToast'
      });
    }, 50);
}

today = new Date();
static refreshData() {
  AppComponent.UpdateNotification =
    setInterval(() => {
     // console.log('test');
    }, 30000);
}

static cancelPageRefresh() {
  if (AppComponent.UpdateNotification) {
      clearInterval(AppComponent.UpdateNotification );
  }
}

ngAfterViewInit() {
  const totalWidth = document.querySelectorAll(".navbar-static-top")[0].clientWidth;
  const logoWidth = document.getElementsByName("techLogo")[0].clientWidth;
  const renalWidth = document.getElementsByName("renalLogo")[0].clientWidth;

  const dropWidth = document.querySelectorAll(".dropdown-toggle")[0].clientWidth;
  AppComponent.MenuWidth = totalWidth - (logoWidth + renalWidth + dropWidth + 100);
}

  public static ScrollDown() {
    setTimeout(() => {

    const element = document.getElementsByClassName('wrapper')[0];
    element.scrollTop = element.scrollTop - 100;
    }, 100);

  }

  public static ShowLoader() {

    if (AppComponent.loading !== true) {
      AppComponent.loading = true;
    }
  }
  public static HideLoader() {
    if (AppComponent.loading !== false) {
      AppComponent.loading = false;
    }
  }
  getLoading() {
    return AppComponent.loading;
  }
  getAlerts() {
    return AppComponent.alerts;
  }
  // Shows and hides the loading spinner during RouterEvent changes
  navigationInterceptor(event: RouterEvent): void {
    (document.querySelectorAll('.main-header')[0]  as HTMLElement).removeAttribute('style');
    if (event instanceof NavigationStart) {
      AppComponent.ShowLoader();
    }
    if (event instanceof NavigationEnd) {
      AppComponent.HideLoader();
    }

    // Set loading state to false in both of the below events to hide the spinner in case a request fails
    if (event instanceof NavigationCancel) {
      AppComponent.HideLoader();
    }
    if (event instanceof NavigationError) {
      AppComponent.HideLoader();
    }
  }

  openTermsAndConditionDialog(): void {
     this.dialogRef = this.dialog.open(TermsAndConditionDialog, {
      position: { right: '0', top: '0' },
      height: '100%',
      width: '850px'
    });
    this.dialogRef.afterClosed().subscribe(result => {
    });
  }

  openPrivacyPolicy(): void {
    this.dialogRef = this.dialog.open(PrivacyPolicyDialog, {
      position: { right: '0', top: '0' },
      height: '100%',
      width: '850px'
    });
    this.dialogRef.afterClosed().subscribe(result => {
    });
  }

  openJMeet(): void {
      //var url = Globals.apiUrl.replace('api/','') + "views/JMeet.html";
      //window.open(url,"_blank");
      this.router.navigate(['JMeet/Live']);
  }

  ngOnInit(){
    this.versionCheck.initVersionCheck(Globals.CurrentSiteUrl + '/version.json');
  }
 
    onFabClick() {

    let alert: any = document.querySelectorAll('ngb-alert div')[0];
    let footer: any = document.getElementById('grFooter');
    let mywrapper: any = document.getElementById('mywrapper');
    let content: any = document.getElementsByClassName('content')[0];

    if (alert) {
      alert.style.position = 'relative';
      alert.parentElement.style.bottom = '-18px';
      alert.style.bottom = '-18px';

    }

    if (content) {
      content.style.paddingBottom='0px';
    }

    footer.classList.remove("no-print");
    footer.style.position = 'relative';

    mywrapper.style.paddingBottom = "0px";
    var dom = document.getElementById('mainBody');


    // let dom = this.domcontainer.nativeElement
    if (dom) {
      AppComponent.ShowLoader();
      var thisvar = this;
      setTimeout(() => {
        domtoimage.toPng(dom)
        .then(function (dataUrl) {
          AppComponent.HideLoader();
          thisvar.OpenErrorDialog(dataUrl);
        })
        .catch(function (error) {
          AppComponent.HideLoader();
          console.error('oops, something went wrong while capturing image!', error);
        })
      });


      //  NEED TO UPDATE AFTER WARDS
      html2canvas(dom).then(canvas => {
        const img = canvas.toDataURL();
        AppComponent.HideLoader();

        thisvar.OpenErrorDialog(img);
        if (alert) {
          alert.removeAttribute("style");
        }

        footer.classList.add("no-print");
        footer.removeAttribute("style");
        mywrapper.removeAttribute("style");
        if (content) {
          content.removeAttribute("style");
        }


      }).catch(function (error) {
        AppComponent.HideLoader();
        console.error('oops, something went wrong while capturing image!', error);
        if (alert) {
          alert.removeAttribute("style");
          alert.parentElement.removeAttribute("style");
        }

        footer.classList.add("no-print");
        footer.removeAttribute("style");
        mywrapper.removeAttribute("style");
        if (content) {
          content.removeAttribute("style");
        }
      });
    }
    else {
      this.OpenErrorDialog(null);
    }
  }

    OpenErrorDialog(img) {
      const dialogRef = this.dialog.open(ErrorDialog, {
        position: { right: '0', top: '0' },
        height: '100%',
        width: '700px',
        data: { imgURL: img, title: 'Error Image' }
      });
  
      dialogRef.afterClosed().subscribe(result => {
        //  console.log('Image dialog was closed');
      });
    }
}
